module.exports = __webpack_public_path__ + "static/media/f74a4693473c730d460c97e0996a36ee.30b22f84.jpg";